<template>
  <div>
    <h1>Carwash</h1>
    <button @click="carwashStore.turnOnBay(1)">Turn On Bay 1</button> For 10 minutes
    <button @click="carwashStore.blink(1)">Test Blink</button>
  </div>
</template>

<script>
export default {
  name: 'Carwash',
  inject:['pumpStatusPage'],
  computed:{
    carwashStore(){
      return this.pumpStatusPage.$refs.carwashStore
    },
  },
}
</script>

<style>
</style>
